import {coleccion_de_libro_diario} from '@/FirebaseConfig'
import {secondsToFullTimestamp, obtener_periodo, periodo_de_fecha} from '@/Helper.js' 
import Vue from 'vue'
import Vuex from 'vuex'
import { async } from 'q';
export default {
    namespaced:true,
    state: {
        debe: '',
        seleccionar: [],
        reglas_seleccionadas: [],
        dialog: false,
        monto: 0,
        record: {},
        registro_pagos: {}
    },
    actions: {
        getAll: async (context, {cuenta_o_pago, cuenta})=>{
            let cont = (cuenta_o_pago==undefined) ? false : true
            let ref= coleccion_de_libro_diario
            if(cont){
                ref = ref.where('haber', '>', 0).where('atendido', '==', false).where('primer_digito', '==', '4')                
            }
            else{
                 ref = ref.where('primer_digito', '==', cuenta).where('haber', '>', 0)   
            }
            ref= await ref.get()
            const record = []
            ref.docs.map(item =>{
                record.push({key: item.id, ...item.data()})
            })
            return record
        },
        recorrido_arreglo: ({state})=>{
            console.log(state.reglas_seleccionadas)
            state.seleccionar.map( ({codigo, haber, key})=>state.reglas_seleccionadas.push({
                codigo: codigo, monto: haber, key: key     
            }))
            state.monto=state.reglas_seleccionadas.map(item=>item.monto).reduce((a, b)=>a+b, 0)           
        },  
        limpiar: (context)=>{
            context.state.debe= ''
            context.state.seleccionar= []
            context.state.reglas_seleccionadas= []
            context.state.dialog= false
            context.state.monto= 0
        },
        pagar:  async (context, {conjunto_partidas, partida_pago, proveedor, fecha_caducidad, referencia, fecha})=>{
            let reglas = conjunto_partidas.map(({codigo, monto, key})=> {
                console.log(codigo, monto)
                return ({
                    porcentaje: 100,
                    valor_porcentuado: monto,
                    debe: codigo,
                    haber: partida_pago
                })}
            )
            console.log(reglas)
            context.dispatch('Movimientos_contables/regla_independiente', {
                valor: 0,
                reglas,
                dato_1: (proveedor) ? proveedor: '',
                dato_2: (fecha_caducidad) ? fecha_caducidad : '',
                dato_3: (referencia) ? referencia :'Carga inicial',
                dato_4: (fecha) ? secondsToFullTimestamp(fecha) : secondsToFullTimestamp(new Date()),
                dato_5: (fecha) ? periodo_de_fecha(fecha) : obtener_periodo()
            }, {root: true})

            conjunto_partidas.map(({key})=> coleccion_de_libro_diario.doc(key).update({atendido: true}) )
            context.dispatch('limpiar')
        }
    },
    getters: {
        registro: state =>Object.keys(state.record).map(item => ({...state.record[item], key: item }))
    }
}